"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../../providers/CetComponentsProvider");
var _hooks = require("../../../../hooks");
const useStyles = props => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    isSuccess
  } = props;
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const ccSocialShareBtnStyle = (0, _react.useMemo)(() => {
    const btnDeviceProps = () => {
      const justifyContent = isMobileView ? 'start' : 'center';
      return {
        justifyContent
      };
    };
    const btnSuccessProps = () => {
      const border = isSuccess ? `1px solid ${themeColors?.general.success}` : 'none';
      return {
        border
      };
    };
    const ccSocialShareBtn = (0, _css.css)({
      position: 'relative',
      background: themeColors?.general.light,
      display: 'flex',
      columnGap: pxToRem(4),
      alignItems: 'center',
      width: '100%',
      height: '100%',
      borderRadius: pxToRem(10),
      padding: pxToRem(8),
      ...btnDeviceProps(),
      ...btnSuccessProps(),
      '&[id=link]': {
        color: themeColors?.primary.main,
        top: pxToRem(-1),
        height: `calc(100% + ${pxToRem(3)})`,
        background: 'transparent'
      },
      '&[id=whatsapp]': {
        color: '#32d34f'
      }
    });
    const ccSocialShareBtnIcon = (0, _css.css)({
      width: pxToRem(24),
      height: pxToRem(24),
      display: 'flex',
      img: {
        width: '100%',
        height: '100%'
      }
    });
    const ccSocialShareBtnText = (0, _css.css)({
      fontWeight: 'bold',
      fontSize: pxToRem(16),
      color: themeColors?.general.text
    });
    return {
      ccSocialShareBtn,
      ccSocialShareBtnIcon,
      ccSocialShareBtnText
    };
  }, [isMobileView, isSuccess, pxToRem, themeColors?.general.light, themeColors?.general.success, themeColors?.general.text, themeColors?.primary.main]);
  return {
    'cc-SocialShare__option__btn': ccSocialShareBtnStyle.ccSocialShareBtn,
    'cc-SocialShare__option__btn__icon': ccSocialShareBtnStyle.ccSocialShareBtnIcon,
    'cc-SocialShare__option__btn__text': ccSocialShareBtnStyle.ccSocialShareBtnText
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;